import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete, useNavigation } from "@refinedev/core";
import { errorNotification, successNotification } from "../../../helpers";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

type NewsDeleteProps = {
  id: number;
  title: string;
  type?: "page" | "table";
};

export const NewsDelete: FC<NewsDeleteProps> = ({
  id,
  title,
  type = "table",
}) => {
  const { modalProps, show, close } = useModal();
  const { mutate: deleteMutate } = useDelete();
  const { push } = useNavigation();

  const handleDelete = () => {
    deleteMutate({
      dataProviderName: "newsDataProvider",
      resource: "news",
      id: "",
      meta: {
        id,
      },
      ...successNotification({
        successData: {
          message: `Новость «${title}» успешно удалена`,
          type: "success",
        },
        callback: () => {
          close();
          push("/news");
        },
      }),
      ...errorNotification({}),
    });
  };

  return (
    <>
      {type === "table" ? (
        <Button
          size={"small"}
          danger
          onClick={show}
          block
          icon={<DeleteOutlined />}
        >
          Удалить
        </Button>
      ) : (
        <Button danger onClick={show} block icon={<DeleteOutlined />}>
          Удалить новость
        </Button>
      )}

      <Modal
        okText={"Удалить"}
        cancelText={"Отмена"}
        onOk={handleDelete}
        title={"Подтверждение"}
        onCancel={close}
        {...modalProps}
      >
        Вы уверены что хотите удалить новость «{title}»?
      </Modal>
    </>
  );
};
